<template>
  <div v-if="showable">
    <v-list-item
      @click.stop="click(item)"
      ripple
      :inactive="item.pages.includes(page)"
      class="no-padding-transition"
      :class="elementClass"
      :data-test="`${item.title}MenuLink`"
    >
      <v-list-item-action>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          <v-icon style="float: right" v-if="submenu">
            {{ submenuExpanded ? "expand_less" : "expand_more" }}
          </v-icon>
          {{ item.title }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-expand-transition v-if="submenu">
      <div
        v-show="!navCollapsed && submenuExpanded"
        style="white-space: nowrap"
      >
        <v-list-item
          v-for="(subItem, i) in showableSubmenu"
          :inactive="subItem.pages.includes(page)"
          :class="{ 'nav-active': subItem.pages.includes(page) }"
          @click.stop="click(subItem)"
          :key="`submenu-${i}`"
          :data-test="`${item.title}${subItem.title}MenuLink`"
        >
          <v-list-item-content>
            <v-list-item-title class="ml-5 pl-5">
              {{ subItem.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  name: 'NavLink',
  props: {
    item: Object,
    navCollapsed: Boolean,
    page: String
  },
  data () {
    return {
      submenu: 'submenu' in this.item,
      submenuExpanded: false
    }
  },
  computed: {
    /**
     * Classes to be applied to <v-list-item>
     */
    elementClass () {
      const submenuActive =
        this.submenu &&
        (this.navCollapsed || !this.submenuExpanded) &&
        this.item.submenu.some((subItem) => subItem.pages.includes(this.page))

      return {
        'nav-active': this.item.pages.includes(this.page) || submenuActive,
        'pl-4': this.navCollapsed,
        'align-icons': !this.navCollapsed
      }
    },
    /**
     * Show nav link according to entitlements and env features
     *
     * @return {Boolean}
     */
    showable () {
      const hiddenLinks =
        this.$store.getters['app/environment'].getFeature('HIDDEN_LINKS')

      const isHidden =
        this.item.title in hiddenLinks && hiddenLinks[this.item.title] === '*'

      const isPassedEntitlements =
        !('can' in this.item) || ('can' in this.item && this.item.can)

      return isPassedEntitlements && this.isShowableSubmenu && !isHidden
    },
    /**
     * Show submenu links according to entitlements
     *
     * @return {Boolean}
     */
    isShowableSubmenu () {
      return !('submenu' in this.item) || this.showableSubmenu.length > 0
    },
    /**
     * List of showable submenu links
     */
    showableSubmenu (links) {
      const hiddenLinks =
        this.$store.getters['app/environment'].getFeature('HIDDEN_LINKS')
      return (this.item.submenu || []).filter(
        (link) => !(link.title in hiddenLinks) && (!('can' in link) || link.can)
      )
    }
  },
  methods: {
    /**
     * When clicking on an item, either use the custom action (function), open a submenu or go to the specified link
     *
     * @param item
     */
    click (item) {
      if ('action' in item) {
        item.action()
      } else if ('link' in item) {
        this.$emit('update:nav-collapsed', true)
        if (this.$route.path !== item.link) {
          this.$router.push(item.link)
        }
      } else if ('submenu' in item) {
        if (this.navCollapsed) {
          // Force the nav to be expanded whe showing the submenu
          this.$emit('update:nav-collapsed', false)
          this.submenuExpanded = true
        } else {
          this.submenuExpanded = !this.submenuExpanded
        }
      }
    }
  }
}
</script>

<style lang="sass">
.nav-active
  background: rgba(255, 255, 255, 0.15)

.align-icons
  & > a, & > div
    padding-left: 16px !important
</style>
